import { styled } from "styled-components";

export const Liking = styled.span`
  font-size: 24px;
`;
